export const isProd = () => window.origin.includes("app.steto.care");

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export type Required<T, K extends keyof T> = Pick<T, K> & Omit<Partial<T>, K>;
